import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 22 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H13.5C13.5834 0.5 13.6636 0.532868 13.7227 0.591797L21.0078 7.87695C21.0668 7.9359 21.0995 8.01626 21.0996 8.09961V23C21.0996 24.933 19.5326 26.5 17.5996 26.5H4C2.067 26.5 0.5 24.933 0.5 23V4C0.5 2.067 2.067 0.5 4 0.5Z",
			fill: "url(#paint0_linear_10430_48218)",
			stroke: "#D5D7DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 0.337891V4.10039C13.5 6.30953 15.2909 8.10039 17.5 8.10039H21.2625",
			stroke: "#D5D7DA"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10430_48218",
			x1: 10.8,
			y1: 0,
			x2: 10.8,
			y2: 27,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F5F5F5"
			})]
		}) })
	]
});
export default SvgDocumentIcon;
